import { React } from 'libs/react';
import { FormRichTextInput } from 'components/form/LazyFormRichTextInput';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import './DealClientNotesPanel.scss';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
/**
 * @component DealClientNotesPanel
 * @since 1.0.0
 */
export function DealClientNotesPanel(props) {
    var _a;
    const { deal } = props;
    const notes = (_a = deal.notes) !== null && _a !== void 0 ? _a : '';
    const { updateDealField } = useDealConfiguratorContext();
    return (React.createElement("div", { className: "deal-client-notes-panel" },
        React.createElement(FormGroup, null,
            React.createElement(FormField, null,
                React.createElement(FormRichTextInput, { name: "notes", label: t('Client notes'), infos: t('This notes are visible by the client after the budget summary.'), value: notes, onChange: (value) => {
                        updateDealField('notes', value, 'string');
                    } })))));
}
